import React, { FC, useContext } from 'react'
import { Button, Result } from 'antd'
import { AuthContext } from '../../components/auth-provider/AuthProvider'

export const ForbiddenPage: FC = () => {
    const { logOut } = useContext(AuthContext)

    return (
        <Result
            status="403"
            title="Access Denied"
            subTitle="Your account is not authorized to access this dashboard. Please contact an administrator if you believe this is a mistake."
            extra={
                <Button type="primary" onClick={logOut}>
                    Log out
                </Button>
            }
        />
    )
}
